import { Pipe, PipeTransform } from '@angular/core';
import { map, Observable, timer } from 'rxjs';

@Pipe({
  name: 'countdown',
})
export class CountdownPipe implements PipeTransform {
  public transform(
    date: Date,
    type: 'DD' | 'HH' | 'MM' | 'SS' | 'HHMMSS' | 'MSS' | 'SSMM' = 'SSMM'
  ): Observable<string> {
    if (type === 'HHMMSS') {
      return timer(0, 1000).pipe(
        map(() => {
          return this.msToHHMMSS(date ? date.getTime() - Date.now() : 0);
        })
      );
    }

    if (type === 'MSS') {
      return timer(0, 1000).pipe(
        map(() => {
          return this.msToMSS(date ? date.getTime() - Date.now() : 0);
        })
      );
    }

    if (type === 'SS') {
      return timer(0, 1000).pipe(
        map(() => {
          return this.msToSS(date ? date.getTime() - Date.now() : 0);
        })
      );
    }

    if (type === 'MM') {
      return timer(0, 1000).pipe(
        map(() => {
          return this.msToMM(date ? date.getTime() - Date.now() : 0);
        })
      );
    }

    if (type === 'HH') {
      return timer(0, 1000).pipe(
        map(() => {
          return this.msToHH(date ? date.getTime() - Date.now() : 0);
        })
      );
    }

    if (type === 'DD') {
      return timer(0, 1000).pipe(
        map(() => {
          return this.msToDD(date ? date.getTime() - Date.now() : 0);
        })
      );
    }

    return timer(0, 10).pipe(
      map(() => {
        return this.msToSSMM(date ? date.getTime() - Date.now() : 0);
      })
    );
  }

  private msToSSMM(msRemaining: number): string {
    if (msRemaining < 0) {
      return '00.00s';
    }

    const ms = this.formattedToTwoDecimal(
      Math.floor((msRemaining % 1000) / 10)
    );
    const seconds = this.formattedToTwoDecimal(Math.floor(msRemaining / 1000));

    return `${seconds}.${ms}s`;
  }

  private msToHHMMSS(msRemaining: number): string {
    if (msRemaining < 0) {
      return '00:00:00';
    }

    const hours = this.formattedToTwoDecimal(
      Math.floor(msRemaining / (1000 * 60 * 60))
    );
    const minutes = this.formattedToTwoDecimal(
      Math.floor((msRemaining % (1000 * 60 * 60)) / (1000 * 60))
    );
    const seconds = this.formattedToTwoDecimal(
      Math.floor((msRemaining % (1000 * 60)) / 1000)
    );

    return `${hours}:${minutes}:${seconds}`;
  }

  private msToMSS(msRemaining: number): string {
    if (msRemaining < 0) {
      return '0:00';
    }

    const minutes = Math.floor((msRemaining % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = this.formattedToTwoDecimal(
      Math.floor((msRemaining % (1000 * 60)) / 1000)
    );

    return `${minutes}:${seconds}`;
  }

  private msToSS(msRemaining: number): string {
    if (msRemaining < 0) {
      return '00';
    }
    const seconds = this.formattedToTwoDecimal(
      Math.floor((msRemaining % (1000 * 60)) / 1000)
    );
    return `${seconds}`;
  }

  private msToMM(msRemaining: number): string {
    if (msRemaining < 0) {
      return '00';
    }
    const minutes = Math.floor((msRemaining % (1000 * 60 * 60)) / (1000 * 60));

    return `${minutes}`;
  }

  private msToHH(msRemaining: number): string {
    if (msRemaining < 0) {
      return '00';
    }
    const hours = this.formattedToTwoDecimal(
      Math.floor(23 - new Date().getHours())
    );

    return `${hours}`;
  }

  private msToDD(msRemaining: number): string {
    if (msRemaining < 0) {
      return '00';
    }
    const days = this.formattedToTwoDecimal(
      Math.floor(msRemaining / (1000 * 60 * 60 * 24))
    );

    return `${days}`;
  }

  private formattedToTwoDecimal(value: number) {
    return value < 10 ? `0${value}` : value;
  }
}
